export default {
  setdaysToDate (state: {[key:string]: number}, val: number) {
    state.daysToDate = val
  },
  setDisplayYear (state: any, year: string) {
    state.displayYear = year
  },
  setAgrinoteImgDate (state: any, year: number) {
    state.agrinoteImgDate = year
  },
  setAgrinoteMainImgDate (state: any, year: number) {
    state.agrinoteImgDate = year
  },
  setAgrinoteMainImgId (state: any, id: number) {
    state.agrinoteImgId = id
  },
  setMaxDate (state: any, date: string) {
    state.maxDate = date
  }
}
